
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15.5","cy":"15.5","r":"11.625","fill":"#5935DD"}}),_c('path',{attrs:{"d":"M29.708 15.5A14.209 14.209 0 0015.5 1.292V15.5h14.208z","stroke":"#fff","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"4.521","cy":"14.854","r":"4.521","fill":"#E345FF"}})])
          )
        }
      }
    